<p [class.mobile]="isMobile">{{text}}</p>
